import axios from 'axios';
import { createSignedPostRequest } from 'utils/createSignedRequestsHelpers';

export const getShadowProjectsByIds = async (
  shadowProjectIds,
  activeEmployerInfo = {}
) => {
  const apiPath = 'shadow-data/projects/by-ids';

  const signedRequest = await createSignedPostRequest({
    apiPath,
    body: { ids: shadowProjectIds },
    activeEmployerInfo,
  });

  const response = await axios(signedRequest);

  return response.data;
};
